// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3QM77","left":"InfoRow_left__1tEdw"};